/* eslint-disable max-len */
import * as yup from 'yup';

export const initialFlowState = {
  isLoading: true,
  isSuccess: '',
  isButtonLoading: false,
  isDeleteModalOpen: false,
}

export const initialFormState = {
  questionAm: '',
  questionEn: '',
  questionRu: '',
  answerAm: '',
  answerEn: '',
  answerRu: '',
}

export const createFaqSchema = yup.object().shape({
  questionAm: yup.string().required('Question is required.').max(250, 'Question must contain at least maximum length 250'),
  questionEn: yup.string().required('Question is required.').max(250, 'Question must contain at least maximum length 250'),
  questionRu: yup.string().required('Question is required.').max(250, 'Question must contain at least maximum length 250'),
  answerAm: yup.string().optional().max(10000, 'Answer must contain at least maximum length 10000').nullable(),
  answerEn: yup.string().optional().max(10000, 'Answer must contain at least maximum length 10000').nullable(),
  answerRu: yup.string().optional().max(10000, 'Answer must contain at least maximum length 10000').nullable(),
});
